export default function isValidText(value) {
    return typeof value === 'string' && value
        .length > 0;
}
